/**
 * Circuit breaker for authentication retry storms
 * Prevents infinite retry loops when auth service is down
 */

const FAILURE_THRESHOLD = 3;
const STORAGE_KEY = 'sb-bowfiwvwkrsvmcaglvtg-auth-token';

class AuthCircuitBreaker {
  private failureCount = 0;
  private lastFailureTime: number | null = null;
  private isBlocked = false;

  recordFailure(error: any): void {
    const is503 = error?.status === 503 || 
                  error?.message?.includes('503') ||
                  error?.message?.includes('upstream connect error');

    if (!is503) {
      return; // Only track 503 errors
    }

    this.failureCount++;
    this.lastFailureTime = Date.now();

    console.log(`[AuthCircuitBreaker] Failure ${this.failureCount}/${FAILURE_THRESHOLD}`);

    if (this.failureCount >= FAILURE_THRESHOLD && !this.isBlocked) {
      this.isBlocked = true;
      console.error('[AuthCircuitBreaker] Threshold reached - clearing auth tokens');
      this.clearAuthTokens();
    }
  }

  recordSuccess(): void {
    this.failureCount = 0;
    this.lastFailureTime = null;
    this.isBlocked = false;
  }

  shouldBlock(): boolean {
    return this.isBlocked;
  }

  reset(): void {
    this.failureCount = 0;
    this.lastFailureTime = null;
    this.isBlocked = false;
  }

  private clearAuthTokens(): void {
    try {
      localStorage.removeItem(STORAGE_KEY);
      console.log('[AuthCircuitBreaker] Auth tokens cleared from localStorage');
    } catch (e) {
      console.error('[AuthCircuitBreaker] Failed to clear tokens:', e);
    }
  }
}

export const authCircuitBreaker = new AuthCircuitBreaker();
